import {extendTheme} from '@chakra-ui/react';

import {styles} from './styles';
import {colors} from './foundations/colors';

const overrides = {
  styles,
  colors,
};

export default extendTheme(overrides);
